import { Order } from './order';
import { ReleaseDateFilter } from './release-date-filter';

export class SearchRequest {
    searchString: string;
    searchFields: string[] = ['de_materialName_t', 'en_materialName_t'];
    biNumbers: string[] = [];
    casNumbers: string[] = [];
    materialNumbers: string[] = [];
    supplierNumbers: string[] = [];
    ecProductNumbers: string[] = [];
    basNumbers: string[] = [];
    validityAreaFilters: string[] = [];
    languageFilters: string[] = [];
    genVarFilters: string[] = [];
    supplierNameFilters: string[] = [];
    supplierNumberFilters: string[] = [];
    sourceFilters: string[] = [];
    materialTypeFilters: string[] = [];
    mksFilters: string[] = [];
    releaseDateFilter: ReleaseDateFilter = new ReleaseDateFilter();
    orders: Order[] = [];
    itemsPerPage = 20;
    page: number;
    advancedSearch: boolean;
    fuzzy: boolean;
}
